import {
  CheckIcon,
  ClockIcon,
  XMarkIcon,
  ChatBubbleLeftEllipsisIcon,
  ArrowRightOnRectangleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";

interface SystemMessageDividerProps {
  body: string;
}

const getIcon = (body: string) => {
  const text = body.toLowerCase();

  if (text.includes("ended")) {
    return { Icon: XMarkIcon, color: "text-red-500" };
  }
  if (text.includes("accepted") || text.includes("joined")) {
    return { Icon: CheckIcon, color: "text-emerald-500" };
  }
  if (text.includes("left the chat")) {
    return { Icon: ArrowRightOnRectangleIcon, color: "text-slate-400" };
  }
  if (text.includes("start typing")) {
    return { Icon: ChatBubbleLeftEllipsisIcon, color: "text-blue-500" };
  }
  if (text.includes("sent") || text.includes("welcome")) {
    return { Icon: ClockIcon, color: "text-blue-500" };
  }
  return { Icon: InformationCircleIcon, color: "text-slate-400" };
};

export const SystemMessageDivider: React.FC<SystemMessageDividerProps> = ({
  body,
}) => {
  const { Icon, color } = getIcon(body);

  return (
    <div className="flex items-center gap-3 my-2 px-2">
      <div className="flex-1 h-px bg-slate-200 shrink" />
      <div className="flex items-center gap-1.5 text-xs text-slate-500 min-w-0 max-w-[75%]">
        <Icon className={`w-3.5 h-3.5 shrink-0 ${color}`} />
        <span className="break-words">{body}</span>
      </div>
      <div className="flex-1 h-px bg-slate-200 shrink" />
    </div>
  );
};
